import type { FC } from 'react';
import type { TPageIntroProps } from './PageIntro.types';
import classNames from 'classnames';

export const PageIntro: FC<TPageIntroProps> = ({
  children,
  className,
  subtitle,
  title,
}) => {
  const wrapperClassNames = classNames('c-page-intro', className);

  return (
    <div className={wrapperClassNames}>
      <h2 className="c-page-intro__title">{title}</h2>

      {!!subtitle && <p className="c-page-intro__subtitle">{subtitle}</p>}

      {children}
    </div>
  );
};
